<div class="offers-control-panel">
    <div class="offers-control-panel__left">
        <div class="offers-control-panel__show-filters-btn"
             [ngClass]="{
                'offers-control-panel__show-filters-btn--checked': filtersService.filtersExpanded
            }">
            <button class="btn"
                    (click)="filtersService.toggleFiltersVisibility()">
                <img class="offers-control-panel__show-filters-btn__icon--unchecked" [src]="showFiltersButtonIcon">
                <img class="offers-control-panel__show-filters-btn__icon--checked" [src]="showFiltersButtonIconChecked">
                {{ 'OFFERS_CONTROL_PANEL.showFiltersButtonLabel' | translate }}
            </button>
        </div>
        <div class="offers-control-panel__left__divider"></div>
        <div class="offers-control-panel__filter">
            <div class="offers-control-panel__filter__label">
                {{ 'OFFERS_CONTROL_PANEL.filterLabel' | translate }}
            </div>
            <app-insurance-coverages-section [offersControlPanelContext]="true"
                                             (coverageCheckedUpdate)="onCoverageCheckedUpdate($event)"
                                             (update)="onFilterUpdate($event)">
            </app-insurance-coverages-section>
        </div>
    </div>
  <div class="offers-control-panel__offers-amount">
    <span *ngIf="offersAmount > 0"> {{'NEXT_OFFERS_SECTION.haveFound' | translate}} </span>
    <span *ngIf="offersAmount > 0">
                                <span>{{ offersAmount }}</span>
      {{ offersAmount | amountNounTranslation:translationsContainer:true | async }}
                            </span>
<!--    <span *ngIf="noOffersForFilters">{{ 'OFFER_SECTION.noOffersForFilters' | translate }}</span>-->
  </div>

    <div class="offers-control-panel__open-filters-btn">
        <button class="btn btn--blue" (click)="openFilters()">
            <img [src]="openFiltersButtonIcon">
            {{ 'OFFERS_CONTROL_PANEL.openFiltersButtonLabel' | translate }}
        </button>
    </div>

    <div class="offers-control-panel__offers-view">
        <app-radio-checkbox-tile [content]="radioCheckboxTileContent"
                                 [contentData]="tilesContentData"
                                 [bean]="bean"
                                 [errorsMap]="formFactoryService.errorsMap"
                                 [control]="formGroup.controls[SectionFieldKey.OFFERS_VIEW]"
                                 [fieldConfig]="formFactoryService.fieldConfig(SectionFieldKey.OFFERS_VIEW, formConfig)"
                                 (changeEvent)="onFieldChange($event)">
        </app-radio-checkbox-tile>
    </div>
</div>

<ng-template #radioCheckboxTileContent let-data="data">
    <div class="offers-control-panel__offers-view-option">
        <div class="offers-control-panel__offers-view-option__icon">
            <img class="offers-control-panel__offers-view-option__icon--unchecked" [src]="data.icon">
            <img class="offers-control-panel__offers-view-option__icon--checked" [src]="data.iconChecked">
        </div>

        <div class="offers-control-panel__offers-view-option__caption">
            {{ data.caption | translate }}
        </div>
    </div>
</ng-template>
